<template>
  <div class="promo-container">
    <!-- {{ subCart }} -->
    <div v-if="subCart.promo_code && !subCart.admin_promo_code" class="block clear clearfix mt-10">
      <p class="promo-code">
        {{ subCart.promo_code }}
        <!-- {{ codeType }} -->
      </p>
      <p class="discount-description"></p>
      <p class="discount-amount">
        Discount: - ${{ subCart.promo_code_amount.toFixed(2) }}
        <img
          width="18"
          height="18"
          class="delete-promo-code"
          src="@/assets/img/icons/icon-circle-remove.svg"
          @click="deleteClick(subCart.promo_code)"
        />
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "FreeShippingPromoCode",
  props: {
    subCart: {
      type: Object,
      required: true,
    },
    deleteClick: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      message: "Hello Vue!",
    };
  },
  computed: {
    codeType() {
      console.log(this.subCart);
      return this.subCart.promo_code;
    },
  },
  methods: {
    // your methods
  },
};
</script>

<style lang="scss" scoped>
.promo-container {
  position: relative;
  padding: 0;
  margin: 0;
  padding: 15px;
  border: 0;
  background: #efefef;
  border-radius: 4px;
  .promo-code {
    font-size: 14px;
    font-weight: bold;
  }
  .discount-description .discount-amount {
    /* text-align: right; */
  }
  img.delete-promo-code {
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
  }
}
</style>
